// extracted by mini-css-extract-plugin
module.exports = {"cart-message":"styles_cart-message__q0QlZ"};